import { createFileRoute } from "@tanstack/react-router"
import { z } from "zod"

import {
  CompanyRunPage,
  companyRunTabs,
} from "@/admin/monitoring/company-run-page"
import { loadCompanyRunResearch } from "@/admin/monitoring/company-run-research-data"
import { ResearchCategory } from "@/constants/terminal/research-category"

const searchSchema = z.object({
  category: z.nativeEnum(ResearchCategory).optional(),
  monitoringRunId: z.string().uuid().optional(),
  researchTaskId: z.string().uuid().optional(),
  tab: z.enum(companyRunTabs).default("research"),
})

const CompanyRunRoute = () => {
  const navigate = Route.useNavigate()
  const search = Route.useSearch()
  const research = Route.useLoaderData()
  // Category, tab and Research Task live in the URL but change only part of
  // the page, so they keep the reader's scroll position.
  const updateSearch = (next: Partial<typeof search>) =>
    void navigate({
      search: { ...search, ...next },
      replace: true,
      resetScroll: false,
    })
  return (
    <CompanyRunPage
      key={research.companyRunId}
      research={research}
      tab={search.tab}
      category={search.category}
      onSelectCategory={(category) => updateSearch({ category })}
      researchTaskId={search.researchTaskId ?? null}
      onSelectTab={(tab) => updateSearch({ tab })}
      onOpenResearchTask={(researchTaskId) =>
        updateSearch({ researchTaskId: researchTaskId ?? undefined })
      }
      onSelectRun={(companyRunId) =>
        void navigate({ params: { companyRunId }, search: { tab: "research" } })
      }
    />
  )
}

export const Route = createFileRoute(
  "/_terminalAdmin/terminal/admin/$companyRunId"
)({
  validateSearch: searchSchema,
  loader: ({ params: { companyRunId } }) =>
    loadCompanyRunResearch({ data: { companyRunId } }),
  component: CompanyRunRoute,
})
